import React, { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { usePermissions } from '../contexts/PermissionContext';
import { useAuth } from '../contexts/AuthContext';

const PermissionRoute = ({
  resource,
  action,
  requireRole,
  redirectTo = '/chat',
  children
}) => {
  const { hasPermission } = usePermissions();
  const { user } = useAuth();
  const [hasAccess, setHasAccess] = useState(null); // null = loading

  useEffect(() => {
    let cancelled = false;

    // requireRole gates on the role ALONE — no permission check. Needed because
    // hasPermission() returns true for super_admin *and* for anyone holding the
    // resource permission, so it can't express "super_admin only".
    if (requireRole) {
      setHasAccess(user?.role === requireRole);
      return undefined;
    }

    const checkAccess = async () => {
      const access = await hasPermission(resource, action);
      if (!cancelled) setHasAccess(access);
    };
    checkAccess();

    return () => { cancelled = true; };
  }, [resource, action, hasPermission, requireRole, user?.role]);

  // Still loading
  if (hasAccess === null) return null;

  // No access
  if (!hasAccess) return <Navigate to={redirectTo} />;

  // Has access
  return children ? children : <Outlet />;
};

export default PermissionRoute;
